export const EMAIL_REGEX =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const PHONE_REGEX = /^([0-9۰-۹]+-?)+[0-9۰-۹]+$/;

export const NUMBER_REGEX = /[0-9]{4}/;

export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;

export const SHABA_REGEX = /^(?=.{24}$)[0-9]*$/;

export const BANK_NUMBER_REGEX = /^.{16}$/;

export const NATIONAL_NUMBER_REGEX = /^[0-9]{10}$/;

export const IRAN_PHONE_REGEX = new RegExp("^(\\+98|0)?9\\d{9}$");

export const DELIVERY_TIME = process.env.NEXT_PUBLIC_DELIVERY_TIME;
export const NAMSHI_IMAGE_BASE_URL =
  process.env.NEXT_PUBLIC_NAMSHI_IMAGE_BASE_URL;

export const MOZONO_BASE_API_URL = process.env.NEXT_PUBLIC_MOZONO_BASE_API_URL;
export const MOZONO_SCRAP_URL = process.env.NEXT_PUBLIC_MOZONO_SCRAP_URL;
export const NAMSHI_UAE_BASE_URL = process.env.NEXT_PUBLIC_NAMSHI_UAE_BASE_URL;
export const NAMSHI_UAE_SALE_URL = process.env.NEXT_PUBLIC_NAMSHI_UAE_SALE_URL;
export const BLOG_API_BASE_URL = process.env.NEXT_PUBLIC_BLOG_API_BASE_URL;

export const NAMSHI_MEN_SHOES_URL =
  process.env.NEXT_PUBLIC_NAMSHI_MEN_SHOES_URL;
export const NAMSHI_WOMEN_SHOES_URL =
  process.env.NEXT_PUBLIC_NAMSHI_WOMEN_SHOES_URL;

export const NAMSHI_UAE_SALE_PAGE_COUNT =
  process.env.NEXT_PUBLIC_NAMSHI_UAE_SALE_PAGE_COUNT;

export const NASMHI_BRANDS = [
  "nike",
  "adidas",
  "puma",
  "adidas_originals",
  "kappa",
  "new_balance",
  "under_armour",
  "jordan",
  "vans",
  "reebok",
  "the_giving_movement",
  "converse",
  "koton",
  "anta",
  "new_era",
  "umbro",
  "skechers",
  "tribe_of_6",
  "fila",
  "the_hundreds",
  "asics",
  "squatwolf",
  "the_emirates",
  "castore",
  "huf",
  "speedo",
  "grimey",
  "hummel",
  "obey",
  "champion",
  "fingercroxx",
  "rip_n_dip",
  "dickies",
  "ellesse",
  "hoka_one_one",
  "caps_lab",
  "izzue",
  "musium_div_",
  "poler",
  "karl_kani",
  "edwin",
  "northface",
  "timberland",
  "columbia",
  "reef",
  "primitive",
  "makia",
  "liverpool_fc",
  "nicce_london",
  "nba",
  "alpha_industries",
  "criminal_damage",
  "cayler_sons",
  "mod_wave_movement",
  "phobia",
  "fo",
  "volcom",
  "crep_protect",
  "upscale",
  "cr7",
  "diadora_brand",
  "kangaroos",
  "gaiam",
  "billabong",
  "copyright",
  "reshoevn8r",
  "wknd",
  "frwd",
  "mitchell_and_ness",
  "quiksilver",
  "tommy_hilfiger",
  "blood_brother",
  "camelbak",
  "venum",
  "blender_bottle",
  "everlast",
  "hugo",
  "dunlop",
  "head_watches",
  "itouch",
  "jason_markk",
  "stance",
  "mister_tee",
  "11_degrees",
  "body_sculpture",
  "oakley",
  "calvin_klein_performance",
  "good_for_nothing",
  "mpl_sports",
  "napapijri",
  "iceberg",
  "onitsuka_tiger",
  "sneaker_lab",
  "babolat",
  "campus_sutra",
  "chi_modu",
  "fossil",
  "gym_clothing_co_",
  "siksilk",
  "zoggs",
];

export const NAMSHI_CLOTHINS_SIZE = [
  "XXS",
  "3XL and larger",
  "OS",
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "2XL",
];
export const NAMSHI_SHOES_SIZE = [
  "36",
  "36.5",
  "37 and smaller",
  "37.5",
  "38",
  "38.5",
  "39",
  "39.5",
  "40",
  "40.5",
  "41",
  "41.5",
  "42",
  "42.5",
  "43",
  "43.5",
  "44",
  "44.5",
  "45",
  "45.5",
  "46",
  "46.5",
  "47_and_larger",
];

export const jalaliHolidays = [
  { date: "1403/1/1", description: "جشن نوروز/جشن سال نو" },
  { date: "1403/1/2", description: "عیدنوروز" },
  { date: "1403/1/3", description: "عیدنوروز" },
  { date: "1403/1/4", description: "عیدنوروز" },
  { date: "1403/1/12", description: "روز جمهوری اسلامی" },
  { date: "1403/1/13", description: "جشن سیزده به در" },
  { date: "1403/1/13", description: "شهادت حضرت علی علیه السلام [ ٢١ رمضان ]" },
  { date: "1403/1/22", description: "عید سعید فطر [ ١ شوال ]" },
  { date: "1403/1/23", description: "تعطیل به مناسبت عید سعید فطر [ ٢ شوال ]" },
  {
    date: "1403/2/15",
    description: "شهادت امام جعفر صادق علیه السلام [ ٢٥ شوال ]",
  },
  { date: "1403/3/14", description: "رحلت حضرت امام خمینی" },
  { date: "1403/3/15", description: "قیام 15 خرداد" },
  { date: "1403/3/28", description: "عید سعید قربان [ ١٠ ذوالحجه ]" },
  { date: "1403/4/5", description: "عید سعید غدیر خم [ ١٨ ذوالحجه ]" },
  { date: "1403/4/25", description: "تاسوعای حسینی [ ٩ محرم ]" },
  { date: "1403/4/26", description: "عاشورای حسینی [ ١٠ محرم ]" },
  { date: "1403/6/4", description: "اربعین حسینی [ ٢٠ صفر ]" },
  {
    date: "1403/6/12",
    description: "رحلت رسول اکرم؛شهادت امام حسن مجتبی علیه السلام [ ٢٨ صفر ]",
  },
  { date: "1403/6/14", description: "شهادت امام رضا علیه السلام [ ٣٠ صفر ]" },
  {
    date: "1403/6/22",
    description: "شهادت امام حسن عسکری علیه السلام [ ٨ ربيع الاول ]",
  },
  {
    date: "1403/6/31",
    description:
      "میلاد رسول اکرم و امام جعفر صادق علیه السلام [ ١٧ ربيع الاول ]",
  },
  {
    date: "1403/9/15",
    description: "شهادت حضرت فاطمه زهرا سلام الله علیها [ ٣ جمادي الثانيه ]",
  },
  {
    date: "1403/10/25",
    description: "ولادت امام علی علیه السلام و روز پدر [ ١٣ رجب ]",
  },
  { date: "1403/11/9", description: "مبعث رسول اکرم (ص) [ ٢٧ رجب ]" },
  { date: "1403/11/22", description: "پیروزی انقلاب اسلامی" },
  {
    date: "1403/11/26",
    description:
      "ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان [ ١٥ شعبان ]",
  },
  { date: "1403/12/29", description: "روز ملی شدن صنعت نفت ایران" },
  { date: "1403/12/30", description: "آخرین روز سال" },
];
